import { useState } from 'react'
import { Form, Button, Space, Input, InputNumber, Grid, Message } from '@arco-design/web-react'
import useLocale from '@/utils/useLocale'
import useLang from '@/utils/useLang'
import styles from './style/phone-login.module.less'
import { useRouter } from 'next/router'
import useFormLogin from '@/hooks/useFormLogin'
import { phoneFormValidator } from '@/utils'
import { useCountDown } from 'ahooks'
import { postSmsApi } from '@/api/login'
import { SUCCESS_CODE } from '@/utils/constants'
import useSetFormInviteCode from '@/hooks/useSetFormInviteCode'
import { usePhoneCaptcha } from '@/hooks/usePhoneCaptcha'

const initialValues = { phone: '', code: '', invite_code: '' }

export default function PhoneForm({ onChangeForm }: { onChangeForm: (v: 'email' | 'phone') => void }) {
  const t = useLocale()
  const [form] = Form.useForm()
  const [targetDate, setTargetDate] = useState<number>()
  const [countdown] = useCountDown({
    targetDate,
    onEnd: () => {
      // setIsButtonDisabled(false)
    }
  })
  const [smsBtnLoading, setSmsBtnLoading] = useState(false)
  const isButtonDisabled = countdown !== 0

  const router = useRouter()
  const isLogin = router.pathname.indexOf('/login') > -1
  const event = isLogin ? 'login' : 'signup'
  const lang = useLang()
  const isEnglish = lang === 'en-US'

  // let captcha
  const { onPhoneSubmitClick, loading } = useFormLogin({
    form
  })

  useSetFormInviteCode({ form })
  const handleGetCode = async () => {
    try {
      await form.validate(['phone'])
      setSmsBtnLoading(true)
      const { phone } = form.getFields()
      // 发送短信
      postSmsApi({
        phone: phone,
        event: event
      })
        .then((res) => {
          if (res?.data?.code === SUCCESS_CODE) {
            setTargetDate(Date.now() + 60000)
            Message.success(t['sms_success'])
          } else {
            Message.error(t['sms_error'])
          }
        })
        .finally(() => {
          setSmsBtnLoading(false)
        })
    } catch (e) {
      console.log('catch phone error:', e)
      return
    }
  }
  const { onCaptchaShow } = usePhoneCaptcha(form, handleGetCode)

  return (
    <div className={styles['login-form-wrapper']}>
      <Form form={form} className={styles['login-form']} layout="vertical" initialValues={initialValues} size="large">
        <Form.Item
          label={t['phone_number']}
          field="phone"
          validateTrigger={['onFinish']}
          rules={[{ required: true, validator: phoneFormValidator, message: t['login.form.phone.errMsg'] }]}
        >
          <Input size="large" className={styles.customInput} addBefore="+86" placeholder={t['phone_number']} />
        </Form.Item>
        <Form.Item label={t['verification_code']} required>
          <Grid.Row align="center">
            <Form.Item
              noStyle={{ showErrorTip: true }}
              field="code"
              rules={[{ required: true, message: t['code_errMsg'] }]}
            >
              <InputNumber
                size="large"
                className={styles.customInput}
                hideControl
                placeholder={t['verification_code']}
                min={0}
                style={{ flex: 1 }}
              />
            </Form.Item>
            <Button
              type="primary"
              id="captcha-button"
              onClick={onCaptchaShow}
              className="captcha-btn"
              disabled={isButtonDisabled || smsBtnLoading}
              style={{ height: 48 }}
            >
              {isButtonDisabled
                ? `${Math.round(countdown / 1000)}s ${t['get_verification_code']}`
                : t['get_verification_code']}
            </Button>
          </Grid.Row>
        </Form.Item>
        <Form.Item
          label={t['register.form.invite.label']}
          field="invite_code"
          validateTrigger={['onFinish']}
          // rules={[{ required: true, validator: phoneFormValidator, message: t['login.form.phone.errMsg'] }]}
        >
          <Input size="large" className={styles.customInput} placeholder={t['register.form.invite.placeholder']} />
        </Form.Item>
        <Space size={16} direction="vertical">
          {isLogin ? (
            <span className={styles.emailLogin} onClick={() => onChangeForm?.('email')}>
              {t['email_login']}
            </span>
          ) : isEnglish ? (
            <span className={styles.emailLogin} onClick={() => onChangeForm?.('email')}>
              {t['email_register']}
            </span>
          ) : null}
          <Button
            type="primary"
            long
            onClick={onPhoneSubmitClick}
            loading={loading}
            size="large"
            className={styles['login-form-btn']}
            style={{ height: 48, borderRadius: 8 }}
          >
            {t['login_register']}
          </Button>
        </Space>
      </Form>
    </div>
  )
}
